import React from 'react'
import classes from './Menu.module.css'
import home from './img/icons/home.png' 
import user from './img/icons/user.png' 
import briefcase from './img/icons/briefcase.png' 
import identification from './img/icons/identification (1).png' 
import {NavLink} from 'react-router-dom';




function Menu() {
  return (
    <div className={classes.section}>
        <div className={classes.menu}>
          <nav>
            <ul>
            <li className={classes.lis}><a href="/"><img src={home} className={classes.navIcon} alt="" /><NavLink to="/">HOME</NavLink></a></li>
            <li className={classes.lis}><a href="/about"><img src={user} className={classes.navIcon} alt="" /><NavLink to="/about">ABOUT</NavLink></a></li>
            <li className={classes.lis}><a href="/portfoio"><img src={briefcase} className={classes.navIcon} alt="" /><NavLink to="/portfoio">PORTFOLIO</NavLink></a></li>
            <li className={classes.lis}><a href="/contact"><img src={identification} className={classes.navIcon} alt="" /><NavLink to="/contact">CONTACT</NavLink></a></li>
            </ul>
            {/* <div className={classes.burgerContainer}>
            <div className={classes.burger}>
              <div className={classes.line1}></div>
              <div className={classes.line2}></div>
              <div className={classes.line3}></div>
            </div>
            </div> */}
          </nav>
        </div>
    </div>
  )
}

export default Menu